<app-search>
  <ng-template let-item #body>
    <div class="flex gap-1">
      <div class="text-base text-color">{{item.denominazione}}</div>
      <div class="text-base text-700 font-light">[{{item.idArera}}]</div>
    </div>
  </ng-template>
</app-search>
